module.exports = __webpack_public_path__ + "static/media/id.cd7ecc1e.svg";